<template>
  <div class="kw-flatpicker__group">
    <slot />
    <div
      class="kw-flatpicker__clear"
      data-clear
      :class="{ _visible: showClearBtn }"
    >
      <kw-svgicon name="remove" />
    </div>
  </div>
</template>

<script>
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';

export default {
  name: 'KwFlatpickerWrapper',
  components: {
    KwSvgicon,
  },
  props: {
    showClearBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
};
</script>

<style lang="scss">
.flatpickr-calendar .flatpickr-current-month .cur-year {
  height: 2rem;
  vertical-align: top;
}

.kw-flatpicker {
  &__group {
    position: relative;
  }

  &__clear {
    width: 48px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #6f7f8f;
    position: absolute;
    top: 0;
    right: 1px;
    font-size: 24px;
    z-index: 3;
    cursor: pointer;
    transition: .5s opacity;
    opacity: 0;
    pointer-events: none;

    &._visible {
      opacity: 1;
      pointer-events: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/KwFlatpickerWrapper.vue